import { useContext } from 'react'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { ThemeContext } from './theme-context.ts'
import type { Theme } from './types.ts'

type ThemeStore = {
  theme: Theme
  toggleTheme: () => unknown
  setTheme: (theme: Theme) => unknown
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    set => ({
      theme: 'dark',
      toggleTheme: () => set(state => ({ theme: state.theme === 'dark' ? 'light' : 'dark' })),
      setTheme: (theme: Theme) => set({ theme }),
    }),
    {
      name: 'ui-state/theme',
      partialize: state => ({ theme: state.theme }),
    }
  )
)

export const useTheme = () => {
  const contextTheme = useContext(ThemeContext)
  const storeTheme = useThemeStore(state => state.theme)
  const toggleTheme = useThemeStore(state => state.toggleTheme)
  return { theme: contextTheme ?? storeTheme, toggleTheme }
}
